<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :viewonly="isView"
        >
            <div class="form-section">
                <div class="form-section-title">基础信息</div>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="园区/社区" prop="parkId">
                            <Select
                                v-model="info.parkId"
                                transfer
                                :disabled="!isAdd"
                            >
                                <Option
                                    v-for="item in parkList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.parkName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="楼栋号" prop="floorName">
                            <Input
                                v-model="info.floorName"
                                placeholder
                                disabled
                            >
                                <span slot="append">栋</span>
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="房间号" prop="houseNum">
                            <Input
                                v-model="info.houseNum"
                                :disabled="!isAdd"
                                placeholder="例如101"
                                @input="getHouseNo"
                            />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="房间代码" prop="houseNo">
                            <Input
                                v-model="info.houseNo"
                                placeholder="例如A-1-3"
                                disabled
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="建筑面积" prop="buildArea">
                            <input-number
                                v-model="info.buildArea"
                                placeholder
                                :min="0"
                                @on-blur="buildAreaChange(info)"
                            >
                                <span slot="append">㎡</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="出租类型" prop="rentType">
                            <Select v-model="info.rentType" transfer>
                                <Option
                                    v-for="item in this.dict.rentTypeNew.toList()"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.text }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="装修状态" prop="decorationType">
                            <Select
                                v-model="info.decorationType"
                                transfer
                                :placeholder="isView ? '' : '请选择装修状态'"
                            >
                                <Option
                                    v-for="item in this.dict.decorationType.toList()"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.text }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="装修格局" prop="houseType">
                            <Input v-model="info.houseType" placeholder />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="朝向" prop="orientation">
                            <Select v-model="info.orientation" transfer>
                                <Option
                                    v-for="item in this.dict.orientation.toList()"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.text }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
            </div>
            <div class="form-section">
                <div class="form-section-title">价格信息</div>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="单价" prop="unitPrice">
                            <input-number
                                v-model="info.unitPrice"
                                placeholder
                                :min="0"
                                @on-blur="unitPriceChange(info)"
                            >
                                <span slot="append">元/㎡/月</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <!-- 单价区间 -->
                    <Col span="12">
                        <FormItem
                            label="单价区间"
                            prop="rentInterval"
                            :required="isAdd || isUpdate"
                        >
                            <rent-interval
                                :info="info"
                                @on-min-price-change="minPriceChange"
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="租金" prop="rent">
                            <input-number
                                v-model="info.rent"
                                placeholder
                                :min="0"
                                @on-blur="rentChange(info)"
                            >
                                <span slot="append">元/月</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            label="交租方式"
                            prop="rentMode"
                            :required="isAdd || isUpdate"
                        >
                            <rent-mode
                                isVerify
                                spread-out
                                :depositPayMethod="rentMode.depositPayMethod"
                                :rentPayMethod="rentMode.rentPayMethod"
                                @on-change="changeRentMode($event, info)"
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="常规押金" prop="deposit">
                            <input-number v-model="info.deposit" placeholder>
                                <span slot="append">元</span>
                            </input-number>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem prop="otherDeposit" label="其它押金">
                            <other-deposit :value="info.otherDeposit" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem prop="otherFee" label="其它费用">
                            <other-fee :value="info.otherFee" />
                        </FormItem>
                    </Col>
                </Row>
            </div>
            <div class="form-section">
                <div class="form-section-title">其他信息</div>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="房间配置" prop="facilitys">
                            <room-config :value="info.facilitys" />
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="标签" prop="tags">
                            <Select v-model="info.tags" multiple transfer>
                                <Option
                                    v-for="item in this.dict.houseTag.toList()"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.text }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="wifi密码" prop="wifiPwd">
                            <Input v-model="info.wifiPwd" placeholder></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20" v-if="channelType == 1 ? true : false">
                    <Col span="12">
                        <FormItem label="佣金" prop="commission">
                            <input-number v-model="info.commission" :min="0">
                            </input-number>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="佣金说明" prop="commissionRemark">
                            <Input v-model="info.commissionRemark"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="图片" prop="attachments">
                            <preview-upload
                                v-model="info.attachments"
                                :maxSize="10 * 1024"
                                multiple
                            /> </FormItem
                    ></Col>
                </Row>
            </div>
        </Form>
    </div>
</template>
<script>
import { deepCopy, debounce, yuan, cent } from '_u/helper'
import Dict from '_u/dict'
import mForm from '_v/common/m-form'
import {
    buildAreaChange,
    unitPriceChange,
    rentChange,
    changeRentMode,
} from '@/views/common/u-rent'
import {
    assetsHouseAdd,
    assetsHouseUpdate,
    assetsHouseView,
    assetsHouseNo,
} from '@/api/assets'
import { assetsParkRootList } from '@/api/configuration'

import RentMode from '_vc/fields/rent-mode'
import RentInterval from '_vc/fields/rent-interval'
import RoomConfig from '_vc/fields/room-config'
import OtherFee from '_vc/fields/other-fee'
import OtherDeposit from '_vc/fields/other-deposit'

export default {
    name: 'room-form',
    mixins: [mForm],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        parkId: {
            type: [String, Number],
            default: '',
        },
        floorId: {
            type: [String, Number],
            default: '',
        },
        floorName: {
            type: String,
            default: '',
        },
        // 楼栋的层数
        floorLevel: {
            type: Number,
            default: 0,
        },
        // 是否开启发布模式校验
        enablePublishRules: {
            type: Boolean,
            default: false,
        },
        // 渠道类型
        channelType: {
            type: Number,
            default: 0,
        },
    },
    components: { RentMode, RoomConfig, RentInterval, OtherFee, OtherDeposit },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: this.id,
                ver: '', //版本号
                //
                parkId: this.parkId, // 园区/社区
                floorName: this.floorName, //  楼栋
                floorId: this.floorId, // 楼栋id
                floorNum: '', // 楼层
                houseNum: '', //房间号
                houseNo: '', //  房间代码
                rentType: '', // 出租类型
                buildArea: '', // 建筑面积
                buildArea: '', // 建筑面积
                decorationType: '', // 装修状态
                houseType: '', // 装修格局
                orientation: '', // 朝向
                //
                unitPrice: '', // 单价
                minPrice: '', //(最低单价(分))
                maxPrice: '', //(最高单价(分))
                rent: '', // 租金
                depositPayMethod: '', // 交租方式_押金
                rentPayMethod: '', // 交租方式
                deposit: '', // 常规押金
                otherFee: [], // 其它费用
                otherDeposit: [], // 其它押金
                //
                facilitys: [], // 房间配置
                tags: [], // 标签
                wifiPwd: '', // wifi密码
                commission: '', // 佣金
                commissionRemark: '', // 佣金说明
                attachments: '', // 图片
                remark: '', //备注
            },
            parkList: [], // 园区列表
            rentMode: '', //交租方式
            addRooms: 0,
            rent: '', // 租金
            deposit: '', // 常规押金
            dict: {
                parkType: Dict.NULL,
                decorationType: Dict.NULL,
                rentTypeNew: Dict.NULL,
                orientation: Dict.NULL,
                houseTag: Dict.NULL,
            },
            buildAreaChange: buildAreaChange,
            unitPriceChange: unitPriceChange,
            rentChange: rentChange,
            changeRentMode: changeRentMode,
        }
    },
    computed: {
        ruleValidate() {
            var rules = {}
            if (this.isView) return rules

            // base
            rules = {
                houseNum: [
                    { required: true, message: '房间号必填' },
                    { validator: this.validateHouseNum, trigger: 'blur' },
                ],
                houseNo: [{ required: true, message: '房间代码必填' }],
                buildArea: [{ required: true, message: '建筑面积必填' }],
                rentType: [{ required: true, message: '出租类型必填' }],
                decorationType: [{ required: true, message: '装修状态必填' }],
                houseType: [{ required: true, message: '装修格局必填' }],
                orientation: [{ required: true, message: '朝向必填' }],
                //
                unitPrice: [
                    { required: true, message: '单价必填' },
                    { validator: this.validateUnitPrice },
                ],
                rent: [{ required: true, message: '租金必填' }],
                deposit: [{ required: true, message: '常规押金必填' }],
                //
            }

            if (this.enablePublishRules) {
                Object.assign(rules, {
                    facilitys: [{ required: true, message: '房间配置必填' }],
                    tags: [{ required: true, message: '标签必填' }],
                    commission: [{ required: true, message: '佣金必填' }],
                    commissionRemark: [
                        { required: true, message: '佣金说明必填' },
                    ],
                    attachments: [{ required: true, message: '图片必填' }],
                })
            }

            return rules
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return assetsHouseView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        // 关闭 alter
        closeAlter() {
            this.alterShow = false
        },
        // 获取房间代码
        getHouseNo: debounce(350, function () {
            // 先清空房间号
            this.info.houseNo = ''
            // 新增房间的时候才能修改房间代码
            if (
                this.isAdd &&
                this.info.houseNum &&
                this.info.houseNum.length >= 3
            ) {
                assetsHouseNo({
                    floorName: this.floorName,
                    houseNum: this.info.houseNum,
                }).then((res) => {
                    this.info.houseNo = res.data
                })
            }
        }),
        // 最低价格更改，触发校验
        minPriceChange() {
            this.$refs.info.validateField('unitPrice')
        },
        // 房间代码校验
        validateHouseNum(rule, value, callback) {
            const floorLevel = value.slice(0, value.length - 2)
            if (!value) {
                callback(new Error('房间号必填'))
            } else if (!floorLevel) {
                callback(new Error('房间号必须大于等于3位数'))
            } else if (this.floorLevel && this.floorLevel - floorLevel < 0) {
                callback(
                    new Error(
                        `当前楼栋为${this.floorLevel}层，请先修改楼栋信息`
                    )
                )
            } else {
                callback()
            }
        },
        // 单价校验
        validateUnitPrice(rule, value, callback) {
            if (this.info.unitPrice == 0) callback()
            if (this.info.unitPrice - this.info.minPrice >= 0) callback()

            callback(new Error('单价不得低于最小值'))
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.isView) {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                assetsParkRootList(),
                Dict.get([
                    'park_type',
                    'decoration_type',
                    'rent_type_new',
                    'orientation',
                    'house_tag',
                ]),
            ])
                .then((args) => {
                    var [view, park, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据

                        if (viewData.entity) {
                            viewData = viewData.entity
                        }
                        Object.keys(viewData).forEach(
                            (name) => (viewData[name] = viewData[name] || '')
                        )
                        viewData.unitPrice = viewData.unitPrice
                            ? yuan(viewData.unitPrice)
                            : 0
                        viewData.rent = viewData.rent ? yuan(viewData.rent) : 0
                        viewData.commission = viewData.commission
                            ? yuan(viewData.commission)
                            : 0
                        viewData.deposit = viewData.deposit
                            ? yuan(viewData.deposit)
                            : 0
                        viewData.minPrice = viewData.minPrice
                            ? yuan(viewData.minPrice)
                            : 0
                        viewData.maxPrice = viewData.maxPrice
                            ? yuan(viewData.maxPrice)
                            : 0

                        viewData.facilitys.forEach((v) => {
                            v.price = yuan(v.price)
                        })
                        viewData.otherFee.forEach((v) => {
                            v.amount = yuan(v.amount)
                        })
                        viewData.otherDeposit.forEach((v) => {
                            v.amount = yuan(v.amount)
                        })

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )

                        this.rentMode = {
                            depositPayMethod: viewData.depositPayMethod,
                            rentPayMethod: viewData.rentPayMethod,
                        }

                        this.list = viewData.children
                    }

                    this.parkList = park.data.list
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    const formData = deepCopy(this.info)
                    formData.unitPrice = cent(formData.unitPrice)
                    formData.rent = cent(formData.rent)
                    formData.deposit = cent(formData.deposit)
                    formData.commission = cent(formData.commission)
                    formData.minPrice = cent(formData.minPrice)
                    formData.maxPrice = cent(formData.maxPrice)

                    const data = this.$refs.info.populateData()
                    data.facilitys = data.facilitys || []
                    data.otherFee = data.otherFee || []
                    data.otherDeposit = data.otherDeposit || []
                    data.facilitys.forEach((v) => (v.price = cent(v.price)))
                    data.otherFee.forEach((v) => (v.amount = cent(v.amount)))
                    data.otherDeposit.forEach(
                        (v) => (v.amount = cent(v.amount))
                    )
                    formData.facilitys = JSON.stringify(data.facilitys)
                    formData.otherFee = JSON.stringify(data.otherFee)
                    formData.otherDeposit = JSON.stringify(data.otherDeposit)
                    formData.tags = formData.tags && formData.tags.join(',')

                    if (this.id) {
                        return assetsHouseUpdate(formData)
                    } else {
                        return assetsHouseAdd(formData)
                    }
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped>
.form {
    &-section {
        margin-bottom: 32px;

        &-title {
            font-size: 18px;
            padding-bottom: 8px;
            margin-bottom: 6px;
            border-bottom: solid 1px @c-gray-bd;
        }
    }
}
</style>
